import { createContext, useContext } from 'react';

export const DialogContext = createContext({});

export const useDialogContext = () => {
  const context = useContext(DialogContext);

  if (!context) throw new Error('useSnackbarContext must be use inside SnackbarProvider');

  return context;
};
